@if (user(); as currentUser) {
  @if (!isEditing()) {
    <a [routerLink]="[currentUser.id]"
       class="list-group-item list-group-item-action py-3">
      {{ currentUser.displayName }}
    </a>
  } @else {
    <a class="list-group-item py-3">
      <span class="flex-grow-1">
        {{ currentUser.displayName }}
      </span>
      <button type="button"
              class="btn btn-sm btn-outline-danger border-0"
              [routerLink]="['./']"
              (click)="delete(currentUser)">
        <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
      </button>
    </a>
  }
}